import { atom, atomFamily, selectorFamily } from 'recoil'
import { recoilPersist } from 'recoil-persist'

const { persistAtom } = recoilPersist()

export const appPreferencesState = atom({
  key: 'AppPreferencesState',
  default: {
    disable_job_upload: false,
    disable_job_upload_msg: '',
    disable_job_upload_title: '',
    service_maintenance_mode: false,
  },
})

export const appPreferencesFamily = atomFamily({
  key: 'AppPreferencesFamily',
  default: selectorFamily({
    key: 'AppPreferencesFamily/Default',
    get:
      (param: string) =>
      ({ get }) => {
        const appPreferencesValue = get(appPreferencesState)
        return appPreferencesValue[param]
      },
  }),
})

export const applicantIdState = atom({
  key: 'ApplicantIdState', // unique ID (with respect to other atoms/selectors)
  default: '', // default value (aka initial value)
})

export const searchBarFocusState = atom({
  key: 'SearchBarFocus',
  default: false,
})

export const apContextState = atom({
  key: 'APContext',
  default: false,
})

export const notificationsState = atom({
  key: 'NotificationsState', // unique ID (with respect to other atoms/selectors)
  default: [], // default value (aka initial value)
})

export const inProgressQCAtom = atom({
  key: 'InProgressQCAtom',
  default: [],
})

export const loginOrgState = atom({
  key: 'LoginOrg',
  default: {
    selectionIdx: null,
    roPairs: [],
  },
  effects_UNSTABLE: [persistAtom],
})

export const qcRsInitialAtom = atom({
  key: 'qcRsInitialAtom',
  default: {},
})

export const qcRsPendingEditsAtom = atom({
  key: 'qcRsPendingEditsAtom',
  default: {},
})

export const qcRsInstFilterAtom = atom({
  key: 'qcRsInstFilterAtom',
  default: [{ label: 'All Institutions', value: 'inst_all' }],
})

export const qcRsFiltersAtom = atom({
  key: 'qcRsFiltersAtom',
  default: [{ label: 'New', value: 'rs_new' }],
})

export const qcRsEntryTermFiltersAtom = atom({
  key: 'qcRsEntryTermFiltersAtom',
  default: [{ label: 'All Entry Terms', value: 'entryTerms_all' }],
})

export const qcRsInstIsSelectedAtom = atom({
  key: 'qcRsInstIsSelectedAtom',
  default: false,
})

export const qcRsSelectedInstOptionsAtom = atom({
  key: 'qcRsSelectedInstOptionsAtom',
  default: [{ label: 'All Institutions', value: 'inst_all' }],
})

export const qcRsSelectedEntryTermOptionsAtom = atom({
  key: 'qcRsSelectedEntryTermOptionsAtom',
  default: [{ label: 'All Entry Terms', value: 'entryTerms_all' }],
})

export const qcRsCurrQcDataAtom = atom({
  key: 'qcRsCurrQcDataAtom',
  default: [],
})

export const qcRsReviewStatusValueAtom = atom({
  key: 'qcRsReviewStatusValueAtom',
  default: false,
})
